import { sdk } from "@farcaster/miniapp-sdk";
import style from "./style.module.scss";

export default function WarpletVerse() {
  const handleOpenMiniApp = async (url: string) => {
    try {
      await sdk.actions.openMiniApp({ url });
    } catch (error) {
      console.error("Failed to open mini app:", error);
    }
  };

  const warplets = [
    {
      name: "Religious Warplet",
      src: "/images/religious-warplet.jpg",
      url: "https://farcaster.xyz/miniapps/bavm8AXNrskA/religious-warplet",
    },
    {
      name: "Warplet Mfers",
      src: "/images/warplet-mfers.jpg",
      url: "https://farcaster.xyz/miniapps/XQktyvz1H9zn/warplet-mfers",
    },
    {
      name: "Warplet",
      src: "/images/warplet.jpg",
      url: "https://farcaster.xyz/miniapps/h3oFMWtYq3uR/warplets",
    },
  ];

  return (
    <div className={style.wrapper}>
      <div className={style.background}>
        <img src="/images/warplet-bg.png" alt="" />
      </div>
      <div className={style.gridWrapper}>
        {warplets.map((item) => (
          <button
            key={item.name}
            className={style.gridItem}
            onClick={() => handleOpenMiniApp(item.url)}
          >
            <div className={style.icon}>
              <img src={item.src} alt={item.name} />
            </div>
            <p className={style.name}>{item.name}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
